define([
	"dojo/_base/declare",
	"dojo/dom-class",
	"csi/heading/Boolean"
], function(declare,domClass,BooleanRen) {
	
	return declare(BooleanRen, {
		toHtmlStatic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*ActionData*/actionData) {
			// summary: render icon rather than checkbox
			var value = this._getValue(ctx, h);
			if (value) {
				domClass.add(refNode, "csiActionIcon iconPromo");
				return true;
			}
			
			return false;
		}
	});
});